'use es6';

import PropTypes from 'prop-types';
import PaneSize from 'DesignData/models/PaneSize';
export default function CodeAccordionItem() {}
CodeAccordionItem.displayName = 'CodeAccordionItem';
CodeAccordionItem.propTypes = {
  /**
   * @type {Node} Title to be used in the accordion handle.
   */
  title: PropTypes.node.isRequired,

  /**
   * @type {CodeMirror} The editor used in the accordion.
   */
  codemirror: PropTypes.node.isRequired,

  /**
   * @type {Number|String} Optional id that will be used to identify child editors in the store.
   *                       If not provided the id will be the index of the editor.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @type {Boolean} Default is true. Values in store will take precedence.
   */
  open: PropTypes.bool,

  /**
   * @type {PaneSize} Values in store will take precedence.
   */
  size: PropTypes.instanceOf(PaneSize)
};
CodeAccordionItem.defaultProps = {
  open: true
};